import { useEffect, useState } from 'react';
import { mediaUrl } from '../media/opfs';

/* Object URLs for OPFS files, revoked on unmount.
 *
 * Leaking these is how a long field day turns into a crashed tab: a hundred
 * photo thumbnails at 4MB each is half a gigabyte of retained blobs. */

export function useMediaUrl(filename: string | undefined): string | null {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!filename) {
      setUrl(null);
      return;
    }
    let revoked = false;
    let current: string | null = null;

    void mediaUrl(filename).then((u) => {
      if (revoked) {
        if (u) URL.revokeObjectURL(u);
        return;
      }
      current = u;
      setUrl(u);
    });

    return () => {
      revoked = true;
      if (current) URL.revokeObjectURL(current);
    };
  }, [filename]);

  return url;
}
